import * as helper from "../../helpers/disposition";

import { DYNAMIC_DASHBOARD } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
   dynamicDashboardStatus: false,
   aiChatMsg: [] as any,
   aiChatDashboardMsg: [] as any,
   dashboardImgUrl: ''
};

const dynamicDashboardSlice = createSlice({
  name: DYNAMIC_DASHBOARD,
  initialState,
  reducers: {
    setDynamicDashboardStatus: (state, { payload }) => {
      state.dynamicDashboardStatus = payload
    },
    setAiChatMsg: (state, { payload}) => {
      state.aiChatMsg.push(payload)
    },
    setAiDashBoradReset: (state) => {
      state.aiChatMsg = [];
      state.dashboardImgUrl = ""
    },
    setAiChatDashboardMsg: (state, { payload}) => {
      state.aiChatDashboardMsg.push(payload)
    },
    setAiChatReset: (state) => {
      state.aiChatDashboardMsg = [];
      state.dashboardImgUrl = ""
    },
    setDashboardImgUrl: (state, { payload}) => {
      state.dashboardImgUrl = payload
    },
    reset: () => {},
  }
});

export const DynamicDashboardSliceActions = dynamicDashboardSlice.actions;
export default dynamicDashboardSlice.reducer;
